export const isPWA = () => {
    // @ts-ignore
    const isSafariPWA = !!window.navigator?.standalone;
    const isChromePWA = window.matchMedia('(display-mode: standalone)').matches;
    return isSafariPWA || isChromePWA;
};
